import { render, staticRenderFns } from "./SlaTab.vue?vue&type=template&id=71fb92dc&scoped=true&"
import script from "./SlaTab.vue?vue&type=script&lang=js&"
export * from "./SlaTab.vue?vue&type=script&lang=js&"
import style0 from "./SlaTab.vue?vue&type=style&index=0&id=71fb92dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb92dc",
  null
  
)

export default component.exports